import axios, { AxiosResponse } from "axios";
import { ElMessage } from "element-plus";
// 封装axios
const instance = axios.create({
    // baseURL: '/api/',
    baseURL: 'https://tihaidengta.xyz/',
    // baseURL: 'http://localhost:9001',
    // baseURL: 'http://localhost:8001',
    timeout: 5000
})

// 请求拦截
// 公共函数：获取token并设置请求头
// export const setupHeaders = () => {
//     const token = localStorage.getItem('token');
//     const headers: Record<string, string> = {
//       'Content-Type': 'application/json'
//     };
//     if (token) {
//       headers['token'] = token;
//     }
//     return headers;
//   };
  
instance.interceptors.request.use((config => {
    // 如果有token就带上token发请求
    const token = localStorage.getItem("token");
    if(token){
        if(config.headers){
            config.headers["token"] = token;
        }
    }   
    return config;
}), (err) => {return Promise.reject(err) })



// 响应拦截 并做统一错误捕获
instance.interceptors.response.use(
    (response) => {
        const data = response.data as IResponse<any>;
        if (data.code !== 20000) {
            ElMessage.error(data.message);
        }
        return response.data;
    },
    (err) => {

        ElMessage.error("请求失败，错误信息：" + err.message);
        Promise.reject(err)
    })

export default instance;
